export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8601.1fdff176.jpg";